/**
 * Do not edit directly — generated by `pnpm build-tokens`.
 */

import { theme as AntdTheme, type ThemeConfig } from 'antd';

const { darkAlgorithm, defaultAlgorithm } = AntdTheme;

export const antdThemes: Record<"light" | "dark", ThemeConfig> = {
  light: {
    algorithm: defaultAlgorithm,
    token: {
      colorBgContainerDisabled: "#f3f5f7",
      colorInfoBg: "#ebeefb",
      colorPrimary: "#d2f740",
      colorText: "#0c0c0b",
      colorLink: "#0c0c0b",
      colorLinkHover: "#0c0c0b",
      colorLinkActive: "#0c0c0b",
      colorTextLightSolid: "#0c0c0b",
      colorPrimaryHover: "#d2f740",
      colorBgMask: "rgba(0, 0, 0, 0.65)",
      fontFamily: "'ABC Whyte', sans-serif",
      borderRadius: 4,
      fontSize: 14
    },
    components: {
      Collapse: {
        colorBgContainer: "#ffffff",
        colorFillAlter: "#ffffff",
        colorTextHeading: "#0c0c0b",
        paddingSM: 24,
        padding: 24
      },
      Menu: {
        itemSelectedBg: "#d2f740",
        colorTextDisabled: "#4d4d4d",
        itemMarginInline: 0,
        itemBorderRadius: 0
      },
      Table: {
        colorFillAlter: "#ffffff",
        colorTextHeading: "#0c0c0b",
        colorBgContainer: "#ffffff",
        fontWeightStrong: 400
      },
      Tabs: {
        cardBg: "#151514",
        colorBorder: "transparent"
      },
      Tooltip: {
        colorTextLightSolid: "#ffffff",
        colorBgSpotlight: "#283102"
      },
      Drawer: {
        colorBgElevated: "#f3f5f7"
      },
      DatePicker: {
        colorPrimary: "#396b00"
      },
      Input: {
        colorPrimaryHover: "#396b00",
        controlHeight: 24
      },
      InputNumber: {
        colorPrimaryHover: "#396b00",
        controlHeight: 24
      },
      Select: {
        colorPrimaryHover: "#396b00",
        colorTextPlaceholder: "#4d4d4d",
        controlHeight: 24,
        controlHeightSM: 24,
        fontSize: 12
      },
      Radio: {
        colorPrimary: "#396b00",
        colorPrimaryHover: "#396b00",
        colorPrimaryActive: "#396b00"
      },
      Checkbox: {
        colorPrimary: "#d2f740",
        colorPrimaryHover: "#d2f740"
      },
      Pagination: {
        colorPrimary: "#b3d049",
        colorPrimaryHover: "#b3d049"
      },
      Steps: {
        colorPrimary: "#d2f740",
        colorPrimaryHover: "#d2f740"
      },
      Switch: {
        colorPrimary: "#d2f740",
        colorPrimaryHover: "#d2f740"
      },
      Spin: {
        colorPrimary: "#b3d049"
      },
      Card: {
        boxShadowTertiary: "none"
      },
      Button: {
        lineHeight: 1
      },
      Dropdown: {
        fontSize: 12
      }
    }
  },
  dark: {
    algorithm: darkAlgorithm,
    token: {
      colorBgContainerDisabled: "#222423",
      colorInfoBg: "#050816",
      colorPrimary: "#d2f740",
      colorText: "#ffffff",
      colorLink: "#ffffff",
      colorLinkHover: "#ffffff",
      colorLinkActive: "#ffffff",
      colorTextLightSolid: "#ffffff",
      colorPrimaryHover: "#d2f740",
      colorBgMask: "rgba(0, 0, 0, 0.65)",
      fontFamily: "'ABC Whyte', sans-serif",
      borderRadius: 4,
      fontSize: 14
    },
    components: {
      Collapse: {
        colorBgContainer: "#151514",
        colorFillAlter: "#151514",
        colorTextHeading: "#ffffff",
        paddingSM: 24,
        padding: 24
      },
      Menu: {
        itemSelectedBg: "#d2f740",
        colorTextDisabled: "#edf0f3",
        itemMarginInline: 0,
        itemBorderRadius: 0
      },
      Table: {
        colorFillAlter: "#151514",
        colorTextHeading: "#ffffff",
        colorBgContainer: "#151514",
        fontWeightStrong: 400
      },
      Tabs: {
        cardBg: "#151514",
        colorBorder: "transparent"
      },
      Tooltip: {
        colorTextLightSolid: "#151514",
        colorBgSpotlight: "#283102"
      },
      Drawer: {
        colorBgElevated: "#222423"
      },
      DatePicker: {
        colorPrimary: "#396b00"
      },
      Input: {
        colorPrimaryHover: "#396b00",
        controlHeight: 24
      },
      InputNumber: {
        colorPrimaryHover: "#396b00",
        controlHeight: 24
      },
      Select: {
        colorPrimaryHover: "#396b00",
        colorTextPlaceholder: "#edf0f3",
        controlHeight: 24,
        controlHeightSM: 24,
        fontSize: 12
      },
      Radio: {
        colorPrimary: "#396b00",
        colorPrimaryHover: "#396b00",
        colorPrimaryActive: "#396b00"
      },
      Checkbox: {
        colorPrimary: "#d2f740",
        colorPrimaryHover: "#d2f740"
      },
      Pagination: {
        colorPrimary: "#b3d049",
        colorPrimaryHover: "#b3d049"
      },
      Steps: {
        colorPrimary: "#d2f740",
        colorPrimaryHover: "#d2f740"
      },
      Switch: {
        colorPrimary: "#d2f740",
        colorPrimaryHover: "#d2f740"
      },
      Spin: {
        colorPrimary: "#b3d049"
      },
      Card: {
        boxShadowTertiary: "none"
      },
      Button: {
        lineHeight: 1
      },
      Dropdown: {
        fontSize: 12
      }
    }
  }
};

export type AntdThemeMode = keyof typeof antdThemes;

export const getAntdTheme = (mode: AntdThemeMode): ThemeConfig => antdThemes[mode];

export default antdThemes;
